/**
 * This file was auto-generated by Fern from our API Definition.
 */

export type MembershipRole = "OWNER" | "ADMIN" | "MEMBER" | "VIEWER";
export const MembershipRole = {
  Owner: "OWNER",
  Admin: "ADMIN",
  Member: "MEMBER",
  Viewer: "VIEWER",
} as const;
